"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import SvgIcon from "@mui/material/SvgIcon"
import svg from "./assets/mail.svg"

function MailIcon() {
  return (
    <SvgIcon
      component={svg}
      viewBox="0 0 200 200"
      sx={{
        // color: "#F6F4F4",
        width: "200px",
        height: "200px",
      }}
    />
  )
}

export default MailIcon
